class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.addEventListener("change", this.handleChange);
    requestAnimationFrame(() => this.syncQuickAddFromSwatches());
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.handleChange);
  }

  /**
   * When color swatches exist on a single-variant quick-add form, keep hidden
   * variant id + submit state aligned with the selected swatch.
   */
  syncQuickAddFromSwatches() {
    const variantInput = this.querySelector("[data-plp-variant-input]");
    const submitBtn = this.querySelector("[data-plp-quick-add-submit]");
    if (!variantInput || !submitBtn) return;

    const checked = this.querySelector(".swatch-input__input:checked");
    if (!checked?.dataset?.variantId) return;

    variantInput.value = checked.dataset.variantId;

    const available = checked.dataset.variantAvailable === "true";
    variantInput.disabled = !available;
    submitBtn.disabled = !available;

    const isAddToCart =
      submitBtn.matches('[type="submit"]') && submitBtn.getAttribute("name") === "add";
    if (!isAddToCart || !window.variantStrings) return;

    const label =
      submitBtn.querySelector("[data-plp-add-label]") ||
      submitBtn.querySelector("span:not(.sold-out-message)");
    if (!label) return;

    label.textContent = available
      ? window.variantStrings.addToCart
      : window.variantStrings.soldOut;
  }

  handleChange(event) {
    const input = event.target.closest(".swatch-input__input");
    if (!input || !this.contains(input)) return;

    const imgEl = this.querySelector("[data-card-image]");
    if (input.dataset.variantImage && imgEl) {
      imgEl.src = input.dataset.variantImage;
    }

    if (input.dataset.variantId) {
      this.dataset.selectedVariant = input.dataset.variantId;
    }

    this.syncQuickAddFromSwatches();

    this.dispatchEvent(
      new CustomEvent("product-card:variant-change", {
        detail: {
          variantId: input.dataset.variantId || null,
          variantImage: input.dataset.variantImage || null,
        },
        bubbles: true,
      })
    );
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
